import { Grid, Typography } from "@mui/material";
import SuscrPickOrg from "../../components/Profile/SuscrPickOrg";
import { useSuperAdminSuscripts } from "../../context/SuperAdmin/SuscriptsContext";
import { Spinner } from "../../components/Loading/Spinner";
import SuscriptPanel from "../../components/Table/Suscriptions/SuscriptPanel";
import { useAuthContext } from "../../hooks/Auth";

const SuscriptionsPage = () => {
  const { organizaciones, selectedOrg, handleChange, isLoadingOrgs } =
    useSuperAdminSuscripts();

  const { canAccess } = useAuthContext();

  const isSuperAdmin = canAccess("view:suscriptions");

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
      }}
    >
      {/* Título */}
      <Grid item>
        <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
          <b>Suscripciones & Planes</b> | Suscripciones
        </Typography>
      </Grid>

      {isLoadingOrgs ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Seleccionar organizacion */}
          {isSuperAdmin && (
            <Grid item>
              <SuscrPickOrg
                organizaciones={organizaciones}
                selectedOrg={selectedOrg ? selectedOrg : ""}
                handleChange={handleChange}
                isLoading={isLoadingOrgs}
              />
            </Grid>
          )}

          {/* Menú de suscripciones */}
          {selectedOrg && <SuscriptPanel />}
        </>
      )}
    </Grid>
  );
};

export default SuscriptionsPage;
